export function versionHashes(version) {
    return [...version].sort();
}
export function schemaChangeRows(changes) {
    const rows = [];
    for (const change of changes) {
        if (!change.existedBefore && change.existsAfter)
            rows.push({ table: change.table, change: 'add-table', detail: '' });
        else if (change.existedBefore && !change.existsAfter)
            rows.push({ table: change.table, change: 'drop-table', detail: '' });
        else {
            for (const column of change.columnChanges) {
                const kind = column.before === undefined ? 'add-column'
                    : column.after === undefined ? 'drop-column' : 'change-column';
                const detail = column.before === undefined
                    ? `${column.column}: ${JSON.stringify(column.after)}`
                    : column.after === undefined ? column.column
                        : `${column.column}: ${JSON.stringify(column.before)} -> ${JSON.stringify(column.after)}`;
                rows.push({ table: change.table, change: kind, detail });
            }
            if (change.concurrentDeletesChanged)
                rows.push({ table: change.table, change: 'concurrent-deletes', detail: 'changed' });
            if (change.fksChanged)
                rows.push({ table: change.table, change: 'fks', detail: 'changed' });
            if (change.restrictionsChanged)
                rows.push({ table: change.table, change: 'restrictions', detail: 'changed' });
        }
    }
    return rows;
}
